import { render, staticRenderFns } from "./GroupedInventory.vue?vue&type=template&id=2aaf315b&scoped=true"
import script from "./GroupedInventory.vue?vue&type=script&lang=js"
export * from "./GroupedInventory.vue?vue&type=script&lang=js"
import style0 from "./GroupedInventory.vue?vue&type=style&index=0&id=2aaf315b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf315b",
  null
  
)

export default component.exports